import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { LeadParagraph } from '../../components/LeadParagraph';
export const _frontmatter = {
  "pageTitle": "Visually Hidden API",
  "title": "Visually Hidden",
  "props": ["VisuallyHiddenProps"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const VisuallyHiddenProps = makeShortcode("VisuallyHiddenProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="visually_hidden" type="api" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Using the VisuallyHidden component will hide the children of this component
  visually, while still allowing the content to be accessed by screenreaders.
      </LeadParagraph>
      <h2>{`Basic Usage`}</h2>
      <pre><code parentName="pre" {...{
          "className": "language-tsx"
        }}>{`import React from 'react';
import { VisuallyHidden } from 'react-magma-dom';

export function Example() {
  return (
    <VisuallyHidden>
      This text can be read by a screen reader, but does not appear on the
      screen.
    </VisuallyHidden>
  );
}
`}</code></pre>
      <h2>{`Visually Hidden Props`}</h2>
      <p><strong parentName="p">{`This component uses `}<inlineCode parentName="strong">{`forwardRef`}</inlineCode>{`. The ref is applied to the outer `}<inlineCode parentName="strong">{`div`}</inlineCode>{` element.`}</strong></p>
      <p>{`All of the `}<a parentName="p" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes"
        }}>{`global HTML attributes`}</a>{` can be provided as props and will be applied to the wrapping `}<inlineCode parentName="p">{`div`}</inlineCode>{` element that gets rendered.`}</p>
      <VisuallyHiddenProps mdxType="VisuallyHiddenProps" />
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      